import { useState } from "react";
import { Loader2 } from "lucide-react";
import { MainLayout } from "@/components/layout/MainLayout";
import { useSocialAgent } from "@/hooks/useSocialAgent";
import { SocialAgentPricing } from "@/components/social-agent/SocialAgentPricing";
import { SocialAgentDashboard } from "@/components/social-agent/SocialAgentDashboard";
import { ConnectMetaDialog } from "@/components/social-agent/ConnectMetaDialog";
import { NewPostDialog } from "@/components/social-agent/NewPostDialog";
import { ScheduleDialog } from "@/components/social-agent/ScheduleDialog";
import { AIPostDialog } from "@/components/social-agent/AIPostDialog";

export default function SocialAgentPage() {
  const {
    loading, saving,
    subscription, plans, status, posts, schedule, setSchedule,
    hasSubscription, canPost, canAds,
    handleConnect, handleDisconnect, handleSubscribe, handleActivateTrial,
    handleCreatePost, handleSaveSchedule, handleGenerateAIContent, handlePublishAIPost,
  } = useSocialAgent();

  const [showConnect, setShowConnect] = useState(false);
  const [showNewPost, setShowNewPost] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);
  const [showAIPost, setShowAIPost] = useState(false);

  if (loading) {
    return (
      <MainLayout>
        <div className="flex items-center justify-center py-20">
          <Loader2 className="w-8 h-8 animate-spin text-pink-600" />
        </div>
      </MainLayout>
    );
  }

  if (!hasSubscription) {
    return (
      <MainLayout>
        <SocialAgentPricing
          plans={plans}
          saving={saving}
          onSubscribe={handleSubscribe}
          onActivateTrial={() => handleActivateTrial()}
        />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <SocialAgentDashboard
        subscription={subscription}
        status={status}
        posts={posts}
        schedule={schedule}
        saving={saving}
        canPost={canPost}
        canAds={canAds}
        onDisconnect={handleDisconnect}
        onOpenConnect={() => setShowConnect(true)}
        onOpenNewPost={() => setShowNewPost(true)}
        onOpenAIPost={() => setShowAIPost(true)}
        onOpenSchedule={() => setShowSchedule(true)}
        onSubscribe={handleSubscribe}
      />

      <ConnectMetaDialog
        open={showConnect}
        onOpenChange={setShowConnect}
        saving={saving}
        onConnect={handleConnect}
      />

      <NewPostDialog
        open={showNewPost}
        onOpenChange={setShowNewPost}
        saving={saving}
        onCreatePost={handleCreatePost}
      />

      <ScheduleDialog
        open={showSchedule}
        onOpenChange={setShowSchedule}
        saving={saving}
        schedule={schedule}
        setSchedule={setSchedule}
        onSave={handleSaveSchedule}
      />

      <AIPostDialog
        open={showAIPost}
        onOpenChange={setShowAIPost}
        saving={saving}
        schedule={schedule}
        onGenerate={handleGenerateAIContent}
        onPublish={handlePublishAIPost}
      />
    </MainLayout>
  );
}
